// src/components/GoogleTag.js
import { useEffect } from 'react';

const TAG_ID = 'AW-16960208448';

/**
 * Tag Google Ads.
 *
 * Ladowany dopiero wtedy, gdy strona jest gotowa - tak samo jak kontener GTM
 * w public/index.html. Wczesniej oba skrypty startowaly w trakcie renderowania
 * i razem zjadaly ok. 2 s pracy watku glownego na telefonie.
 *
 * dataLayer wypelniamy natychmiast, wiec konfiguracja czeka gotowa na moment,
 * w ktorym gtag.js faktycznie sie zaladuje - zadne zdarzenie nie przepada.
 */
const GoogleTag = () => {
  useEffect(() => {
    // Prerender zrzuca DOM juz po starcie aplikacji, wiec bez tej straznicy
    // tag mogby wejsc drugi raz na stronie odtworzonej ze zrzutu.
    if (window.__sensoriniAdsTagLoaded || document.querySelector(`script[src*="gtag/js?id=${TAG_ID}"]`)) {
      return undefined;
    }
    window.__sensoriniAdsTagLoaded = true;

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', TAG_ID);

    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${TAG_ID}`;
      script.async = true;
      document.head.appendChild(script);
    };

    const events = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
    events.forEach((ev) => document.addEventListener(ev, start, { once: true, passive: true }));

    const schedule = () => {
      const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 1200));
      idle(start, { timeout: 3000 });
    };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule);

    return () => {
      events.forEach((ev) => document.removeEventListener(ev, start));
      window.removeEventListener('load', schedule);
    };
  }, []);

  return null;
};

export default GoogleTag;
